import { CanDeactivateFn } from '@angular/router';
import { Observable } from 'rxjs';

import { AgricolaPolicyWizardComponent } from '../../components/agricola/agricola-policy-wizard/agricola-policy-wizard/agricola-policy-wizard.component';

// Intercepts every navigation away from the apertura wizard (navbar, logout,
// browser back, etc.) and lets the component decide whether to confirm the exit.
export const agricolaWizardExitGuard: CanDeactivateFn<AgricolaPolicyWizardComponent> = (
  component
): boolean | Observable<boolean> => {
  return component?.canDeactivate ? component.canDeactivate() : true;
};
